var path = '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html';
var html = "<p style=\"padding-top: 0; padding-bottom: 0.5em; font-size: 0.9em;\" translate=sharedModules.core.components.syncContractInfoButton.to_onaji_baai translate-value-target=\"{{ vm.syncTargetName }}\"></p><input type=button id=sync-contract-info-btn class=\"btn btn-sm btn-primary\" value=\"{{ 'sharedModules.core.components.syncContractInfoButton.douki_suru' | translate }}\" style=\"font-size: 0.8em;\" ng-click=vm.syncContractInfoWithBillingInfo()>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/components/sync_contract_info_button/sync_contract_info_button.html
// module id = 1282
// module chunks = 0